export const WIDTH = 100;
export const WIDTH_2 = 1.5;
export const WIDTH_3 = 2.5;
